module.exports = __webpack_public_path__ + "static/columnMenu-c67a3b00af70cec787a88a79e97002e6.gif";